import Search from "../../../components/PageView/PageViewTable/Search";
import SortBy from "../../../components/PageView/PageViewTable/SortBy";
import FiltersButton from "../../../components/SavedFilters/FiltersButton";
import { Query, QueryOrderBy } from "../../../types/GlobalInterfaces";
import { Module } from "../../../types/TenantInterfaces";

interface Props {
  query: Query;
  setQuery: React.Dispatch<React.SetStateAction<Query>>;
  onSearch: (newSearch: string) => void;
  mod?: Module | null;
}

export default function BasicToolbar({
  query,
  setQuery,
  onSearch,
  mod,
}: Props) {
  return (
    <div className="d-flex gap-2">
      <Search alwaysOpen onChange={onSearch} />
      <FiltersButton
        currentModule={mod}
        query={query}
        setQuery={(newQuery: Query) => setQuery(newQuery)}
        onClear={() => setQuery((prev) => ({ ...prev, Filters: [] }))}
        subitemFieldsOnly={false}
        showVariables={false}
      />
      <SortBy
        sortBy={query?.OrderBy || undefined}
        updateSortBy={(newOrderBy: QueryOrderBy | null) =>
          setQuery((prev) => ({ ...prev, OrderBy: newOrderBy }))
        }
        moduleAPIName={mod?.APIName}
      />
    </div>
  );
}
